import { concat, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type { Dropdown } from 'ember-basic-dropdown/types';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface ContextMenuItemSignature {
  Args: {
    description?: string | null;
    dropdown?: Dropdown;
    icon?: string | null;
    iconClass?: string;
    isActive?: boolean;
    isDisabled?: boolean;
    label?: string | number | null;
    onClick?: () => void | Promise<void>;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class UiContextMenuItemComponent extends Component<ContextMenuItemSignature> {
  // Getter and setter
  get hasAction() {
    return Boolean(this.args.onClick);
  }

  // Actions
  callOnClick = () => {
    if (this.args.onClick && !this.args.isDisabled) {
      this.args.dropdown?.actions.close();
      void this.args.onClick();
    }
  };

  // Template
  <template>
    <div
      class={{bem
        (hash
          has-action=this.hasAction is-disabled=@isDisabled is-active=@isActive
        )
      }}
      data-test-ui-context-menu-item
      role='button'
      aria-disabled={{@isDisabled}}
      data-test-ui-context-menu-item-icon={{@icon}}
      {{on 'click' this.callOnClick}}
      ...attributes
    >
      {{#if @icon}}
        {{svgJar @icon class=(concat (bem 'icon') ' ' @iconClass)}}
      {{/if}}
      <div class={{bem 'label'}}>
        {{@label}}
        {{#if @description}}
          <div class={{bem 'description'}}>{{@description}}</div>
        {{/if}}
      </div>
      {{#if (has-block)}}
        <div class={{bem 'action'}}>
          {{yield}}
        </div>
      {{/if}}
    </div>
  </template>
}
